import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Wrapper, Heading, Label } from './s'
import Content from './content'

const Signing = props => {
    if(!props.dokument.signing) {
        return null
    }

    return (
        <Wrapper>
            <Heading>
                <FormattedMessage
                    id="noun_signing"
                    defaultMessage="Signing" />
            </Heading>
            <Label {...props.dokument.signing} />
            <Content {...props} />
        </Wrapper>
    )
}

export default Signing